import React, { Component } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './ChangeFlightsMyJourney.css';
const I18n = require('i18n-react').default;

const defaultProps = {
  buttonModal: 'OK',
  showModal: false
};

const propTypes = {
  id: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  buttonModal: PropTypes.string,
  header: PropTypes.string
};

class ChangeFlightsMyJourney extends Component {
  render() {
    return (
      <Modal id={`modal-${this.props.id}`}
        show={this.props.showModal}
        onHide={this.props.close}
        dialogClassName='dialogClass'
      >
        {this.props.header ? (
          <Modal.Header closeButton>
            <Modal.Title>{this.props.header}</Modal.Title>
          </Modal.Header>
        ) : null}
        <Modal.Body bsClass="modal-changeFlights-body">
          <Row>
            <Col sm={12} xs={12} md={12} lg={12} className="modal-changeFlights-body-content">
              <div className="modal-changeFlights-icon" />
            </Col>
          </Row>
          <Row>
            <Col className="columDescriptionMsg">
              <span className="titleMsg textBold"> {I18n.translate('message.flightChangeMyJourney.titleMsg')}</span>
              <span className="descriptionMsg">
                {I18n.translate('message.flightChangeMyJourney.message')}
                <span className="textBold textUnderline">
                  {I18n.translate('components.flightDetailsModal.contactNumber')}
                </span>
                {I18n.translate('components.flightDetailsModal.otherMessageErrorAriport')}
                <span className="textBold textUnderline">
                  {I18n.translate('components.flightDetailsModal.ohterContactNumber')}
                </span>
                {I18n.translate('components.flightDetailsModal.finalMessageErrorAriport')}
              </span>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer bsClass="modal-changeFlights-footer">
          <Row>
            <Col sm={12} xs={12} md={12} lg={12}>
              <Button
                bsClass="modal-changeFlights-button"
                id={`btn-modal-${this.props.id}`}
                onClick={this.props.close}
                ref={c => (this.closeModal = c)}>
                {this.props.buttonModal}
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

ChangeFlightsMyJourney.defaultProps = defaultProps;
ChangeFlightsMyJourney.propTypes = propTypes;

export default ChangeFlightsMyJourney;



// WEBPACK FOOTER //
// ./src/components/common/modalChangeFlightMyJourney/ChangeFlightsMyJourney.jsx